// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WorkspaceDataInfo } from './WorkspaceInfoResult';
export class WorkSpaceMetaData extends WorkspaceDataInfo {
    constructor() {
        super(...arguments);
        this.fromServer = false;
        this.needLoad = false;
        this.isActive = false;
    }
    FillByDataFromServer(data, isActive) {
        this.ws_id = data.ws_id;
        this.name = data.name;
        this.updateTimeSpan = data.updateTimeSpan;
        this.isActive = isActive;
    }
}
